import React, { useEffect, useState } from 'react';
import { Row, Col } from 'tea-component';
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import { TAB_NAME } from '../../_config/constant';
import EngagementTrends from './EngagementTrends';
import SpendMetricsTrends from './SpendMetricsTrends';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { getDefaultDateValue } from '@/pages/dashboard/_config/defualtTime';
import { PUBG_GAME_CODE_LIST } from '@/pages/dashboard/_config/constant';

import './index.scss'
interface Props {
  gameCode: string;
  filterLoading: boolean;
  formValue: any;
}

const SpendTrendChart = (props: Props) => {
  const { formValue, filterLoading, gameCode } = props;
  const { filterValue, timeType, diff} = formValue
  const { rangeTime, ...filters } = filterValue || {};
  const isPUBGM = PUBG_GAME_CODE_LIST.includes(gameCode)
  const defaultTimeRange = getDefaultDateValue(filterValue?.timeType,false,isPUBGM);
  const rangeTimeArr = diff ? defaultTimeRange : rangeTime

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [engagementData, setEngagementData] = useState([]);
  const [spendData, setSpendData] = useState([]);
  
  const updateEngagementData = () => {
    // 非继承，第一次进入页面折线图区14天、6周、6月
   
    const params = {
      period: TAB_NAME[timeType],
      game_code: gameCode,
      start_time: rangeTimeArr[0],
      end_time: rangeTimeArr[1],
      filters:formatFilterValues(filters)
    };

    setLoading(true);
    dashboardRequest({
      url: `/api/v1/dashboard/ua/spend/engagement_trend`,
      method: 'post',
      data: params,
    })
      .then((data: any) => {
        setEngagementData(data?.nodes);
        setError(false)
      })
      .catch((err) => {
        console.log(err);
        setError(true)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateSpendData = () => {
    // 非继承，第一次进入页面折线图区14天、6周、6月
    const params = {
      period: TAB_NAME[timeType],
      game_code: gameCode,
      start_time: rangeTimeArr[0],
      end_time: rangeTimeArr[1],
      filters:formatFilterValues(filters)
    };

    setLoading(true);
    dashboardRequest({
      url: `/api/v1/dashboard/ua/spend/spend_trend`,
      method: 'post',
      data: params,
    })
      .then((data: any) => {
        setSpendData(data?.nodes);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const update = () => {
    updateEngagementData();
    updateSpendData()
  };

  useEffect(() => {
    if (filterLoading) return;
    update();
  }, [formValue, filterLoading]);

  return (
    <Row className='dbd-ua-trends-box'>
      <Col span={12}>
        <EngagementTrends
          loading={loading}
          error={error}
          data={engagementData}
          timeType={timeType}
        />
      </Col>
      <Col span={12}>
        <SpendMetricsTrends
          loading={loading}
          error={error}
          data={spendData}
          timeType={timeType}
        />
      </Col>
    </Row>
  );
};

export default SpendTrendChart;
